import { Route, Switch, Redirect, useLocation } from 'react-router-dom';
import Login from '../views/Auth/Login';
import PasswordReset from '../views/Auth/PasswordReset';
import RequestPasswordReset from '../views/Auth/RequestPasswordReset';
import SignUp from '../views/Auth/SignUp';
import PaymentSuccess from '../views/PaymentSuccess';

function PublicRoutes() {
	const location     = useLocation();
	const public_paths = [
		`/login`,
		`/request-password-reset`,
		`/password-reset`,
		`/signup`,
		`/payment-success`,
	];

	if(!public_paths.includes(location.pathname)) {
		return <Redirect to="/login" />
	}

	return (
		<Switch>
			<Route exact path="/login" component={Login} />
			<Route exact path="/request-password-reset" component={RequestPasswordReset} />
			<Route exact path="/password-reset" component={PasswordReset} />
			<Route exact path="/signup" component={SignUp} />
			<Route exact path="/payment-success" component={PaymentSuccess} />
		</Switch>
	);
}

export default PublicRoutes;
